
/* JJ: controles de carrito por tarjeta de pendientes; no cambia descuentos. */
(function () {
  'use strict';
  function start() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-jj-card-cart]'));
    if (!cards.length || !window.fetch) return;
    var cart = {items: []};
    var busy = false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var endpoint = function (name) { return root + (name === 'cart.js' ? name : 'cart/' + name); };

    function field(card) { return card.querySelector('[data-jj-card-variant]'); }
    function idOf(card) { return Number(field(card) && field(card).value); }
    function canAdd(card) {
      var el = field(card);
      if (!el) return false;
      var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
      return !!opt && opt.getAttribute('data-jj-available') === 'true';
    }
    function linesFor(variant) {
      return (cart.items || []).filter(function (item) { return Number(item.id) === variant; });
    }
    function render(data) {
      if (data && Array.isArray(data.items)) cart = data;
      cards.forEach(function (card) {
        var variant = idOf(card);
        var quantity = linesFor(variant).reduce(function (sum, item) { return sum + (Number(item.quantity) || 0); }, 0);
        var add = card.querySelector('[data-jj-card-add]');
        var remove = card.querySelector('[data-jj-card-remove]');
        var count = card.querySelector('[data-jj-card-count]');
        var available = canAdd(card);
        add.disabled = busy || !available;
        add.textContent = available ? (quantity > 0 ? 'Añadir otro par' : 'Añadir al carrito') : 'Agotado';
        remove.hidden = quantity <= 0;
        remove.disabled = busy || quantity <= 0;
        count.hidden = quantity <= 0;
        count.textContent = quantity > 0 ? 'En tu carrito: ' + quantity + (quantity === 1 ? ' par' : ' pares') : '';
      });
    }
    function message(card, text) { card.querySelector('[data-jj-card-status]').textContent = text; }

    async function getCart() {
      var response = await fetch(endpoint('cart.js'), {credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
      if (!response.ok) throw new Error('No se pudo consultar el carrito.');
      return await response.json();
    }
    async function post(path, body) {
      var response = await fetch(endpoint(path), {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify(body)
      });
      var data = await response.json().catch(function () {return {};});
      if (!response.ok) throw new Error(data.description || data.message || 'No se ha podido modificar el carrito. Revisa el stock.');
      return data;
    }
    async function perform(card, action) {
      if (busy) return;
      var id = idOf(card);
      if (!id) return;
      if (action === 'add' && !canAdd(card)) return;
      var matching = linesFor(id);
      if (action === 'remove' && !matching.length) {
        try { render(await getCart()); } catch (e) { message(card,'Actualiza la página para consultar el carrito.'); }
        return;
      }
      var saved = false;
      busy = true;
      cards.forEach(function(c){message(c,'');});
      message(card, action === 'add' ? 'Añadiendo…' : 'Quitando…');
      render();
      try {
        if (action === 'add') {
          await post('add.js',{items:[{id:id,quantity:1}]});
        } else {
          var updates = {};
          matching.forEach(function(item){updates[item.key] = 0;});
          await post('update.js',{updates:updates});
        }
        saved = true;
        var updated = await getCart();
        render(updated);
        message(card, action === 'add' ? 'Añadido al carrito.' : 'Quitado del carrito.');
        document.dispatchEvent(new CustomEvent('jj:collection-cart-updated',{detail:updated}));
      } catch (error) {
        message(card, saved ? 'Cambio enviado. Comprueba el carrito para confirmar.' : (error.message || 'No se pudo actualizar el carrito.'));
        if (!saved) {
          try {render(await getCart());} catch (_) {}
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      } finally {
        busy = false;
        render();
      }
    }

    cards.forEach(function (card) {
      var add = card.querySelector('[data-jj-card-add]');
      var remove = card.querySelector('[data-jj-card-remove]');
      var variant = field(card);
      add.addEventListener('click',function(){perform(card,'add');});
      remove.addEventListener('click',function(){perform(card,'remove');});
      if (variant && variant.tagName === 'SELECT') variant.addEventListener('change',function(){message(card,'');render();});
    });
    function refresh() { getCart().then(render).catch(function(){ }); }
    document.addEventListener('jj:everyday-cart-updated',function(event){if(event.detail && Array.isArray(event.detail.items))render(event.detail);});
    document.addEventListener('cart:updated',function(event){if(event.detail && Array.isArray(event.detail.items))render(event.detail);else refresh();});
    window.addEventListener('pageshow',refresh);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();
